import BaseButton from './BaseButton';
import styled from 'styled-components';

type ButtonColor = 'blue' | 'green' | 'red';
interface ButtonProps {
   theme: any;
   color: ButtonColor;
   margin?: string;
}
const SecondaryButton = styled(BaseButton).attrs(({ disabled }) => disabled)`
   color: ${({ theme }) => theme.primaryWhite};
   background-color: ${({ theme, color }: ButtonProps) => {
      switch (color) {
         case 'blue':
            return theme.secondaryBlueLight;
         case 'green':
            return theme.secondaryGreen;
         case 'red':
            return theme.secondaryRed;
      }
   }};
   padding: 10px;
   margin: ${({ margin = '0 auto' }: ButtonProps) => margin};
   &:hover {
      background-color: ${({ theme, color }: ButtonProps) => {
         switch (color) {
            case 'blue':
               return theme.secondaryBlueDark;
            case 'green':
               return theme.primaryGreen;
            case 'red':
               return theme.primaryRed;
         }
      }};
   }
`;

export default SecondaryButton;
